import React from 'react';
import { Link } from 'react-router-dom';
import Bg from '../../images/shapes/bg_pattern_3.svg';
import icon1 from '../../images/icons/icon_mail.svg';
import icon2 from '../../images/icons/icon_calling.svg';
import icon3 from '../../images/icons/icon_map_mark.svg';
import icon4 from '../../images/icons/icon_mail_2.svg';
import aiBadge from '../../images/avatar/aiBadge.png';
import Services from '../../api/service';
import emailjs from "@emailjs/browser";


const Information = [
    { name: "About Laskon", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "Pricing Plan", path: "/pricing" },
    { name: "Privacy Policy", path: "/PrivacyPolicy" }
];

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

// const SubmitHandler = (e) => {
//     e.preventDefault();
// }
const SubmitHandler = (e) => {
    e.preventDefault();

    const email = e.target.email.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === "") {
        alert('Please enter email!');
        return;
    } else if (!emailRegex.test(email)) {
        alert('Please enter a valid email address!');
        return;
    }

    emailjs.send(
        'service_sza58lc',        // Replace with your EmailJS service ID
        'template_fncihwo',       // Replace with your EmailJS template ID
        { email },               // sending only the email
        'vO8dMdmVf4h-7hItT'           // replace with your public key
    ).then(() => {
        alert('Thank you for subscribing!');
        e.target.reset(); // clears the form
    }).catch((err) => {
        alert('Failed to send. Please try again.');
        console.error(err);
    });
};


const Footer = () => {
    return (
        <footer className="site_footer footer_layout_1">
            <div className="content_box position-relative text-white" style={{ backgroundImage: `url(${Bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="container py-5">

                    {/* Contact Icons */}
                    <div className="row justify-content-between text-white mb-5">
                        {/* Write to Us */}
                        <div className="col-md-4 d-flex align-items-start mb-4">
                            <div className="me-3">
                                <img src={icon1} alt="Mail Icon" className="img-fluid" />
                            </div>
                            <div>
                                <h5 className="mb-1 text-white">Write to us</h5>
                                <p className="mb-0 small text-white">sales@laskontech.com</p>
                            </div>
                        </div>

                        {/* Call Us */}
                        <div className="col-md-4 d-flex align-items-start mb-4">
                            <div className="me-3">
                                <img src={icon2} alt="Call Icon" className="img-fluid" />
                            </div>
                            <div>
                                <h5 className="mb-1 text-white">Call Us (UK) &reg;</h5>
                                <p className="mb-0 small text-white">+44 7466 436417</p>
                            </div>
                        </div>

                        {/* Our Office */}
                        <div className="col-md-4 d-flex align-items-start mb-4">
                            <div className="me-3">
                                <img src={icon3} alt="Map Icon" className="img-fluid" />
                            </div>
                            <div>
                                <h5 className="mb-1 text-white">Our Office</h5>
                                <p className="mb-0 small text-white">
                                    Unit 1, Parliament Business Centre, Commerce Way, Liverpool, L8 7BL
                                </p>
                            </div>
                        </div>
                    </div>


                    {/* Footer Main Content */}
                    <div className="footer_main_content pt-4 pb-4">
                        <div className="row justify-content-between">

                            {/* Newsletter */}
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="footer_widget">
                                    <h4 className="footer_info_title border-bottom pb-2 mb-3">Newsletter</h4>
                                    <p className="small text-light mb-3">
                                        Sign up to Laskon Technologies weekly newsletter to get the latest updates.
                                    </p>
                                    <form className="footer_newslatter d-flex flex-wrap align-items-center gap-2" onSubmit={SubmitHandler}>
                                        <div className="d-flex align-items-center bg-light rounded px-2 py-1 flex-grow-1">
                                            <img src={icon4} alt="Mail Icon" className="me-2 " />
                                            <input
                                                id="footer_mail_input"
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                className="form-control border-0 bg-transparent shadow-none text-black"
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-outline-light rounded-circle">
                                            <i className="fa-solid fa-paper-plane"></i>
                                        </button>
                                    </form>
                                    <ul className="social_links_block unordered_list d-flex gap-3 mt-3 ps-0 mb-0">
                                        <li><Link to="https://www.instagram.com/laskon_technologies?igsh=aHZ2Z3lib293MHhh&utm_source=qr" className="text-light text-decoration-none">Instagram</Link></li>
                                        <li><Link to="https://x.com/laskon_tech?s=11&t=rTiTfARWKLzRDbxPxcnpWA" className="text-light text-decoration-none">Twitter</Link></li>
                                        <li><Link to="https://www.linkedin.com/company/laskon-technologies/" className="text-light text-decoration-none">LinkedIn</Link></li>
                                    </ul>

                                </div>
                            </div>

                            {/* Services */}
                            <div className="col-lg-3 col-md-6 mb-4">
                                <div className="footer_widget">
                                    <h4 className="footer_info_title border-bottom pb-2 mb-3">Services</h4>
                                    <ul className="icon_list unordered_list_block list-unstyled text-light small mb-0">
                                        {Services.slice(0, 3).map((service, idx) => (
                                            <li key={idx} className="mb-2">
                                                {service.title && (
                                                    <Link onClick={ClickHandler} to={`/service-single/${service.slug}`} className="text-light text-decoration-none">
                                                        {service.title}
                                                    </Link>
                                                )}
                                            </li>
                                        ))}
                                        <li className="mt-2">
                                            <Link onClick={ClickHandler} to="/service" className="text-light text-decoration-none fw-bold">
                                                View All Services
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Information */}
                            <div className="col-lg-2 col-md-6 mb-4">
                                <div className="footer_widget">
                                    <h4 className="footer_info_title border-bottom pb-2 mb-3">Information</h4>

                                    {/* Flex row only on small screens */}
                                    <div className="d-flex d-lg-block justify-content-between align-items-start">
                                        <ul className="icon_list unordered_list_block list-unstyled text-light small mb-0 me-2">
                                            {Information.map((item, index) => (
                                                <li key={index} className="mb-2">
                                                    <Link onClick={ClickHandler} to={item.path} className="text-light text-decoration-none">
                                                        {item.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>

                                        {/* Show on right in mobile view, below in large screens */}
                                        <a
                                            href="https://www.topdevelopers.co/directory/ai-companies"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="mt-0 mt-lg-3"
                                            style={{ height: '100px' }}
                                        >
                                            <img
                                                src={aiBadge}
                                                alt="TopDevelopers AI Badge"
                                                style={{ height: '100px' }}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    {/* Bottom Strip */}
                    <div className="text-center py-3 mt-4 border-top border-light">
                        <p className="mb-0 small text-light">
                            © {new Date().getFullYear()} Laskon Technologies. All rights reserved. Company No. 16109655
                        </p>
                    </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
